<template>
    <div>
        <template v-if="banners.length > 0">
            <Carousel1 :data="banners" :disableCaption="true" />
        </template>

        <!-- Statistics -->
        <div v-if="statistics.length > 0" class="pt-4 mb-5 small-card bg-site">
            <div class="container">
                <div class="row row-cols-1 row-cols-sm-auto justify-content-evenly p-3 p-sm-0">
                    <!-- <div class="col-12 col-md-6 col-lg-3" v-for="(item, index) in statistics" :key="index"> -->
                    <template v-for="(item, index) in statistics" :key="index">
                        <div v-if="item.title" class="col mb-3 pb-3">
                            <Small :data="item" />
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <!-- Categories -->
        <div v-if="categories.length > 0" class="categories_section mb-2">
            <div class="container">
                <Carousel
                    :value="categories"
                    :numVisible="categories.length >= 2 && categories.length >= 4 ? 4 : categories.length"
                    :numScroll="1"
                    :responsiveOptions="responsiveOptions"
                    :circular="categories.length > 1 ? true : false"
                    :autoplayInterval="categories.length > 1 ? 0 : 0"
                    :showIndicators="categories.length > 1 ? true : false"
                    :showNavigators="categories.length > 1 ? true : false"
                    >
                    <template #item="slotProps">
                        <div v-if="slotProps.data.name" class="mb-3 mb-sm-2">
                            <router-link :to="{'name': 'products_by_category', params: { category_id: slotProps.data.id }}">
                                <Overlay class="rounded category_card ms-sm-3" :data="slotProps.data" />
                            </router-link>
                        </div>
                    </template>
                </Carousel>
            </div>
        </div>

        <div class="container">

            <!-- <div v-if="categories.length > 0" id="categories_section" class="py-4">
                <div class="row row-cols-1 row-cols-md-4">
                    <template v-for="(item, index) in categories" :key="index">
                        <div v-if="item.name" class="col mb-3 mb-sm-2">
                            <router-link :to="{'name': 'products_by_category', params: { category_id: item.id }}">
                                <Overlay class="rounded category_card" :data="item" />
                            </router-link>
                        </div>
                    </template>
                </div>
            </div> -->


            <!-- Store Locator -->
            <!-- <div id="loc_section" class="py-4 mb-4 mb-sm-4">
                <div class="row">
                    <div class="col-sm-6 mb-3 mb-sm-2" v-for="(item, index) in markets" :key="index">
                        <a :href="`/map/${item.id}`">
                            <Box style="background-color: #5E242D; color: white;" :data="item" />
                        </a>
                    </div>
                </div>
            </div> -->

            <!-- <Carousel2 :data="doyouknow" class="mb-5" /> -->
            <div v-if="doyouknow !== undefined && doyouknow.length" id="info_section" class="rounded text-white mb-5">
                <Carousel2 :data="doyouknow" :showNav="false" :showCaption="true">
                    <template #body="{item}">
                        <!-- <div class="h-100 position-absolute start-0 top-0"></div> -->
                        <div class="rounded h-100" :style="`background: url(${item.image}) no-repeat; background-size: cover; background-position: right;`">
                            <div class="row m-2 p-sm-3 h-100">
                                <div class="col-12 col-lg-9 div-info rounded-top text-center mt-3">
                                    <h4>{{ TR.doyouknow }} ?</h4>
                                    <div class="text-center fs-5 d-none">{{ item.title }}</div>
                                </div>
                            <!-- </div>
                            <div class="row m-2 p-sm-3"> -->
                                <div class="col-12 col-lg-9 div-info mb-5 rounded-bottom overflow-y-scroll h-75" style="">
                                    <a :href="item.link" class="cursor-pointer lh-lg" target="_blank" v-html="item.content"></a>
                                </div>
                            </div>
                        </div>
                    </template>
                </Carousel2>
            </div>

            <!-- <div class="info-section" :style="`background: url(${doyouknow.image}) no-repeat; background-size: cover; background-position: right;`">
                <div class="bg-dark bg-opacity-50 rounded">
                    <div class="row m-1 p-sm-5">
                        <div class="col-12 col-lg-9 text-center my-4">
                            <h4>{{ TR.doyouknow }} ?</h4>
                            <div class="text-center fs-5 d-none">{{ doyouknow.title }}</div>
                        </div>
                        <div v-for="(item, index) in doyouknow" :key="index" class="col-12 col-sm-9 mb-2 div-info rounded overflow-hidden" style="height: 300px;">
                        <div class="col-12 col-lg-9 mb-2 div-info rounded overflow-hidden" style="height: 300px;">
                            <a :href="doyouknow.link" class="cursor-pointer lh-lg" target="_blank" v-html="doyouknow.content"></a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Coctails Section -->
            <div v-if="static_board" id="coctails_section" class="mb-5 coctails-section">

                <div class="row g-0 justify-content-start">
                    <div class="col-12 col-lg-5 ms-lg-5 text-center text-lg-left div-info rounded p-0">
                        <!-- <h2 class="headline-1 fs-1 text-uppercase mb-0">Kokteil dünyası</h2>
                        <h3 class="headline-1 fs-5 text-white mb-5">kokteyllərlə dadınızı yüksəldin</h3> -->

                        <!-- <Coctails class="coctails-class" :data="coctails" />
                    </div>
                    <div class="col-lg-4"> -->
                        <!-- <span v-html="TextRing('Cocktail')"></span> -->

                        <svg viewBox="0 0 285 200" class="text-center">
                            <path id="curve-top" stroke="transparent" fill="transparent" class="text-center" d="M 85 60 Q 140 40 195 60 Z"></path>
                            <path id="line-center" stroke="transparent" fill="transparent" class="text-center" d="M 95 120 L 190 120 Z"></path>
                            <path id="curve-bottom" stroke="transparent" fill="transparent" class="text-center" d="M 80 140 Q 140 160 200 140 Z"></path>

                            <router-link :to="{'name': 'products_by_category', params: {category_id: 1}}" target="_self">
                                <text class="svg-text svg-top">
                                    <textPath xlink:href="#curve-top">
                                    Cocktail
                                    </textPath>
                                </text>
                            </router-link>

                            <text class="svg-text svg-center"  fill="white" stroke-width="2">
                                <textPath xlink:href="#line-center">
                                BAR
                                </textPath>
                            </text>

                            <router-link :to="{'name': 'products_by_category', params: {category_id: 2}}" target="_self">
                                <text class="svg-text svg-bottom">
                                    <textPath xlink:href="#curve-bottom">
                                    Mocktail
                                    </textPath>
                                </text>
                            </router-link>
                        </svg>

                    </div>
                </div>

                <!-- <div class="px-4 px-lg-4"></div> -->
            </div>

            <!-- <div class="py-5">
                <Description />
            </div> -->

            <!-- Products -->
            <div v-if="products.length" id="products_section" class="mb-5 bg-light bg-opacity-75 rounded">

                <h2 class="h2 fw-bold pt-3 pb-5 text-center">{{ TR.most_viewed }}</h2>
                <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4">
                    <!-- <div class="col-md-4 col-lg-3 mb-3 mb-sm-4" v-for="(item, index) in products" :key="index"> -->
                    <div class="col m-0 ps-2 mb-3 mb-sm-4" v-for="(item, index) in products.slice(0,8)" :key="index">
                        <Product :data="item" :lang="TR" />
                    </div>
                </div>

                <div class="text-center mt-2">
                    <router-link :to="{name: 'products'}" class="btn btn-dark bg-site rounded px-4">{{ TR.other_products }} <i class="fas fa-angle-double-right ms-2"></i></router-link>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { onMounted, ref, watchEffect } from 'vue';

import { useStore } from "@/store";

import Carousel from 'primevue/carousel';

import Carousel1 from '@/components/carousel/Carousel.vue';
import Carousel2 from '@/components/carousel/Carousel2.vue';
import Small from '@/components/card/Small.vue';
import Overlay from '@/components/card/Overlay.vue';
// import Box from '@/components/card/Box.vue';
// import DoubleInfo from '@/components/card/DoubleInfo.vue';
// import Coctails from '@/components/card/Coctails.vue';
import Product from '@/components/card/Product.vue';
// import Description from '@/components/card/Description.vue';

import { G, ajax } from '@/_common';

export default {
    name: 'HomeP',
    title: 'Ana səhifə',
    components: {
        Carousel1,
        Carousel2,
        Carousel,
        Small,
        // DoubleInfo,
        Product,
        // Description,
        // Coctails,
        Overlay,
        // Box,
    },
    props:{
        data: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        const store = useStore();

        const TR = ref({});

        const banners = ref([]);
        const statistics = ref([]);
        const categories = ref([]);
        const doyouknow = ref({});
        const products = ref([]);

        const static_board = ref(false);
        const responsiveOptions = ref([]);

        watchEffect(() => {
            TR.value = store.getTranslation();
        });


        onMounted(async() => {
			await ajax({
                url: store.getBanners(),
                success: (e) => {
                    const re = /\.be\/([a-zA-Z0-9]+)/mgi;
                    const re1 = /\?v=([a-zA-Z0-9]+)/mgi;
                    e.data.forEach((a) => {
                        if( a.type == 'youtube' ){
                            let b = a.image.match(re);
                            let b1 = a.image.match(re1);
                            let c;
                            if( b ){
                                c = b[0].slice(4);
                            }
                            if( b1 ){
                                c = b1[0].slice(3);
                            }
                            if( c != undefined ){
                                a.image = "https://www.youtube.com/embed/{video_id}?version=3&autoplay=1&mute=1&playsinline=1&playlist={video_id}&controls=0&showinfo=0&enablejsapi=1&autohide=1&modestbranding=1&fs=0&loop=1&rel=0".replace(/\{video_id\}/gi, c);
                            }
                        }
                    });
                    banners.value = e.data;
                }
            });

			await ajax({
                url: store.getStatistics(),
                success: (e) => {
                    statistics.value = e.data;
                }
            });

			await ajax({
                url: store.getCategories(),
                success: (e) => {
                    categories.value = e.data.filter(c => c.code != 'cocktail' && c.code != 'mocktail');


                    responsiveOptions.value = [
                        {
                            breakpoint: '4000px',
                            numVisible: categories.value.length > 5 ? 5 : categories.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '1920px',
                            numVisible: categories.value.length > 4 ? 4 : categories.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '1380px',
                            numVisible: categories.value.length > 3 ? 3 : categories.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '800px',
                            numVisible: 2,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '575px',
                            numVisible: 1,
                            numScroll: 1,
                        }
                    ];
                }
            });

			await ajax({
                url: store.getDoyouknow(),
                success: (e) => {
                    doyouknow.value = e.data;
                }
            });

			await ajax({
				url: store.getProductsByCategory() + '?rows=10',
				success: (e) => {
					products.value = e.data.data;
				}
			});
            static_board.value = true;
		});

        const markets = [
            {
                id: 1,
                name: "Mağazalar",
                icon: "fas fa-map-marked",
            },
            {
                id: 2,
                name: "Hədiyyələr",
                icon: "fas fa-gift",
            },
        ];

        // const TextRing = (text) => {
        //     const CHARS = text.split('');
        //     const INNER_ANGLE = 360 / CHARS.length;
        //     return `<span class="text-ring" style="--total: ${CHARS.length}; --radius: ${1 / Math.sin(INNER_ANGLE / (180 / Math.PI))};">` +
        //         CHARS.map((char, index) => {
        //             return `<span style='--index: ${index}'>${char}</span>`;
        //         }).join('') +
        //     `</span>`;
        // };

        return {
            G,
            TR,
			// slides,
			banners,
            statistics,
            categories,
            doyouknow,
			products,
            markets,
            // coctails,
            // TextRing
            static_board,
            responsiveOptions,
		};
    },
}
</script>


<style lang="scss">
.container{
    padding: 0px;
}
.btn-more{
    padding: 0.8rem 1.5rem;
}
.small-card *{
    color: #ffffff;
}
.div-info{
    background-color: rgba(120, 120, 120, 0.3);
    text-align: justify;
    padding: 20px;
}
.div-info, .div-info a{
    color: #ffffff;
}
.div-info a:hover{
    color: #ffffffcc;
}
.info-section {
    // background: url('~/public/assets/images/doyouknow.jpg') no-repeat;
    // background-size: cover;
    // background-position: right;
    border-radius: 10px;
}
.coctails-class{
    max-height: 300px;
    overflow-y: scroll;
}
.coctails-section{
    height: 500px;
    max-height: 500px;
    padding: 30px;
    color: #ffffff;

    background: url('~/public/assets/images/coctails.png') no-repeat;
    background-size: cover;
    background-position: right;
    border-radius: 10px;

    .btn{
        border-radius: 30px;
    }
}

@media(max-width: 576px){
    .coctails-section{
        height: auto;
    }
    .div-info{
        height: 100% !important;
        line-height: normal !important;
        overflow: auto;
        background-color: rgba(120, 120, 120, .8);
    }
}

.svg-text{
    // width: 500px;
    fill: #d3e5ef;
    // font-weight: bold;
    // font-size: 46pt;
    // font: 46pt Verdana, Helvetica, Arial, sans-serif;
    font: 24pt "Keter YG";
    // dominant-baseline="auto" width="500" fill="white" font-weight="bold" style="font-size: 46pt;"
}
.svg-top{
    dominant-baseline: auto;
}
.svg-bottom{
    dominant-baseline: hanging;
}
.svg-center{
    font-size: 36pt;
    // color: linear-gradient(-30deg, #261a52, rgb(115, 5, 5), rgb(160, 63, 8));
    stroke: #8d2626;
    fill: #d3e5ef;
}

.svg-top:hover, .svg-bottom:hover{
    fill: #58b3e4;
}

// .rainbow{
//     background-image: -webkit-gradient( linear, left top, right top, color-stop(0, #f22), color-stop(0.15, #f2f), color-stop(0.3, #22f), color-stop(0.45, #2ff), color-stop(0.6, #2f2),color-stop(0.75, #2f2), color-stop(0.9, #ff2), color-stop(1, #f22) );
//     background-image: gradient( linear, left top, right top, color-stop(0, #f22), color-stop(0.15, #f2f), color-stop(0.3, #22f), color-stop(0.45, #2ff), color-stop(0.6, #2f2),color-stop(0.75, #2f2), color-stop(0.9, #ff2), color-stop(1, #f22) );
//     color:transparent;
//     -webkit-background-clip: text;
//     background-clip: text;
// }

.category_card.card{
    // width: 400px;
    height: 300px;
    border-radius: 10px;
}

.categories_section
{
    .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
        background-color: rgb(var(--site-primary-color-rgb)) !important;
    }
    .p-carousel-prev-button, .p-carousel-next-button{
        background: rgb(var(--site-primary-color-rgb));
        border-radius: 50%;
        color: #ffffff;
    }
}
</style>
